export enum KnowledgeBaseContentLevel {
    Free = -1,
    General = 0,
    P = 1,
    P1 = 2,
    P2 = 3,
    P3 = 4,
}
